import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const IMAGES = ['https://cdn.magicpatterns.com/uploads/8FumtxCvCyNxuZFUrQXjBG/1.webp', 'https://cdn.magicpatterns.com/uploads/bgHsjVpsePShotZLEvsrYk/2.webp', 'https://cdn.magicpatterns.com/uploads/r5uGrBazmqH7mYssXWGKed/3.webp', 'https://cdn.magicpatterns.com/uploads/mtsKRKDNjaoC5xGMtdi7kj/4.webp', 'https://cdn.magicpatterns.com/uploads/dSHywLKymSTAhxaFqLE9dY/5.webp',
// Placeholders for the next 5 images
'https://cdn.magicpatterns.com/uploads/8FumtxCvCyNxuZFUrQXjBG/1.webp', 'https://cdn.magicpatterns.com/uploads/bgHsjVpsePShotZLEvsrYk/2.webp', 'https://cdn.magicpatterns.com/uploads/r5uGrBazmqH7mYssXWGKed/3.webp', 'https://cdn.magicpatterns.com/uploads/mtsKRKDNjaoC5xGMtdi7kj/4.webp', 'https://cdn.magicpatterns.com/uploads/dSHywLKymSTAhxaFqLE9dY/5.webp'];
export function ProductPreviewCarousel() {
  // Duplicate images for seamless infinite scroll
  const duplicatedImages = [...IMAGES, ...IMAGES];
  return <section className="py-20 bg-transparent relative z-10 overflow-hidden pt-[30px] pb-[30px]" data-id="element-261">
      <div className="max-w-7xl mx-auto px-4 mb-12 text-center" data-id="element-262">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-black text-[#0f1711] mb-4 tracking-tight" data-id="element-263">
          Echá un vistazo al{' '}
          <span className="text-[#8b7355]" data-id="element-264">interior del recetario</span>
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-[#3e2723]/70 font-serif italic" data-id="element-265">
          Diseños profesionales, explicaciones claras y sabiduría ancestral en
          cada página
        </motion.p>
      </div>

      <div className="relative flex overflow-hidden" data-id="element-266">
        <motion.div className="flex gap-6 px-3" animate={{
        x: [0, -2500] // Adjust based on total width
      }} transition={{
        duration: 40,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-267">
          {duplicatedImages.map((src, index) => <div key={index} className="relative shrink-0 w-[280px] md:w-[400px] group" data-id="element-268">
              <img src={src} alt={`Página del producto ${index + 1}`} className="w-full h-auto block transition-transform duration-700 group-hover:scale-105" loading="lazy" data-id="element-269" />
            </div>)}
        </motion.div>
      </div>

      <div className="mt-12 text-center" data-id="element-270">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-block px-6 py-3 bg-[#8b7355]/10 border border-[#8b7355]/30 rounded-full text-[#8b7355] font-black uppercase tracking-widest text-sm" data-id="element-271">
          Más de 200 páginas de contenido exclusivo
        </motion.div>
      </div>
    </section>;
}